<template>
  <div>
    <b-tabs
      small
      card
      fill
    >
      <b-tab title="Configration">
        <b-form-group label="Select the required indicators">
          <b-form-checkbox v-model="$store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].configration.showApprovers">Approvers</b-form-checkbox>
          <b-form-checkbox v-model="$store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].configration.showEmail">Email</b-form-checkbox>
        </b-form-group>
        <div v-if="$store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].configration.showEmail">
          <b-form-group
            class="mt-3"
            label="Email Tags:"
          >
            <multiselect
              v-model.lazy="$store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].configration.emailTags"
              label="text"
              track-by="value"
              :options="emailTagsOptions"
              :multiple="true"
              :taggable="true"
            ></multiselect>
          </b-form-group>
          <b-form-group
            class="mt-3"
            label="Platform Setting:"
          >
            <multiselect
              v-model.lazy="$store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].configration.platformSettings"
              label="platform_variable_name"
              track-by="platform_variable_value"
              :options="platformSettingOptions"
              :multiple="true"
              :taggable="true"
            ></multiselect>
          </b-form-group>
        </div>
      </b-tab>
      <b-tab
        title="Approvers"
        v-if="$store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].configration.showApprovers"
      >
        <b-overlay
          :show="isLoading"
          rounded="sm"
        >
          <b-card>
            <b-row>
              <b-col cols="6">
                <b-navbar
                  toggleable="lg"
                  type="dark"
                  variant="light"
                >
                  <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
                  <b-navbar-brand
                    href="#"
                    class="text-dark"
                  >
                    <strong>Select List of Employees</strong>
                  </b-navbar-brand>

                  <b-collapse
                    id="nav-collapse"
                    is-nav
                  >
                    <!-- Right aligned nav items -->
                    <b-navbar-nav class="ml-auto">
                      <b-nav-form>
                        <b-form-group
                          label-cols-sm="3"
                          label-align-sm="right"
                          label-size="sm"
                          label-for="filterInput"
                        >
                          <b-input-group size="sm">
                            <b-form-input
                              v-model="filter"
                              type="search"
                              id="filterInput"
                              placeholder="Type to Search"
                            ></b-form-input>
                            <b-input-group-append>
                              <b-button
                                :disabled="!filter"
                                @click="filter = ''"
                              >Clear</b-button>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                      </b-nav-form>
                    </b-navbar-nav>
                  </b-collapse>
                </b-navbar>
                <b-table
                  bordered
                  class="mx-1"
                  sticky-header="calc(100vh - 220px)"
                  ref="table"
                  id="employee-complaints-table"
                  :busy.sync="isLoading"
                  :fields="staticFields"
                  :items="getEmployeeTableData"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  no-sort-reset
                >
                  <template v-slot:cell(contact_name)="data">{{ data.item.first_name+' '+data.item.last_name }}</template>
                  <template v-slot:cell(actions)="data">
                    <b-button
                      :disabled="$store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].approvers.approversList.length > 0"
                      variant="primary"
                      @click="onSelectedEmployee(data)"
                    >>>></b-button>
                  </template>
                </b-table>
                <p class="text-center mt-3">
                  Showing Result From
                  <b>{{fromRows}}</b> to
                  <b>{{toRows}}</b>
                </p>
                <b-row>
                  <b-col cols="2">
                    <b-form-select
                      v-model="perPage"
                      id="perPageSelect"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select>
                  </b-col>
                  <b-col>
                    <b-pagination
                      class="float-right"
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                      first-text="First"
                      prev-text="Prev"
                      next-text="Next"
                      last-text="Last"
                      aria-controls="employee-complaints-table"
                    ></b-pagination>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="6">
                <p>Selected Employee List</p>
                <b-table-simple
                  bordered
                  responsive="sm"
                >
                  <b-thead>
                    <b-tr>
                      <b-th>Index</b-th>
                      <b-th>Employee Name</b-th>
                      <b-th>Actions</b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr
                      v-for="(employeeList,employeeIndex) in $store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].approvers.approversList"
                      :key="employeeIndex"
                    >
                      <b-td>{{ employeeIndex+1+'.' }}</b-td>
                      <b-td>{{ employeeList.name }}</b-td>
                      <b-td>
                        <font-awesome-icon
                          v-b-tooltip.hover
                          title="Delete"
                          icon="trash"
                          :class="'ml-2 text-danger'"
                          @click="deleteSelectedEmployee(employeeIndex)"
                        />
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </b-col>
            </b-row>
          </b-card>
        </b-overlay>
      </b-tab>
      <b-tab
        title="Email"
        v-if="$store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].configration.showEmail"
      >
        <b-card>
          <b-tabs
            small
            nav-class="complaints-languages-tabs-layout"
          >
            <b-tab
              v-for="(emailLanguage,lanuageIndex) in selectedLanguage"
              :key="lanuageIndex"
              :title="emailLanguage.text"
            >
              <b-tabs
                justified
                vertical
                pills
                small
                fill
              >
                <b-tab title="New Complaint Request To Approver">
                  <label class="mt-3">New Complaint Request To Approver</label>
                  <div class="my-2">
                    <b-row>
                      <b-col cols="6">
                        <b-card>
                          <b-card-body
                            class="p-0"
                            style="height: 70px;overflow-y: auto;"
                          >
                            <span
                              v-for="(tags, tagsIndex) in $store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].configration.emailTags"
                              :key="tagsIndex"
                              class="mr-2"
                            >
                              <b-badge
                                variant="success"
                                style="cursor: pointer;"
                              >
                                <p @click="setTagValue('[['+tags.text+']]', complaintTypeIndex, emailLanguage.value, 'Complaint Request To Approver')">{{ tags.text }}</p>
                              </b-badge>
                            </span>
                          </b-card-body>
                        </b-card>
                      </b-col>
                      <b-col cols="6">
                        <b-card>
                          <b-card-body
                            class="p-0"
                            style="height: 70px;overflow-y: auto;"
                          >
                            <span
                              v-for="(platform, platformIndex) in $store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].configration.platformSettings"
                              :key="platformIndex"
                              class="mr-2"
                            >
                              <b-badge
                                variant="success"
                                style="cursor: pointer;"
                              >
                                <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', complaintTypeIndex, emailLanguage.value, 'Complaint Request To Approver')">{{ platform.platform_variable_name }}</p>
                              </b-badge>
                            </span>
                          </b-card-body>
                        </b-card>
                      </b-col>
                    </b-row>
                  </div>
                  <b-form-group label="Email Subject">
                    <b-form-input
                      v-model="$store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].emails[emailLanguage.value].newComplaintRequestToApprover.subject"
                      size="sm"
                    ></b-form-input>
                  </b-form-group>
                  <b-spinner
                    v-if="newComplaintRequestToApproverRender"
                    label="Spinning"
                  ></b-spinner>
                  <b-form-group
                    v-else
                    label="Email Body"
                  >
                    <wysiwyg v-model="$store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].emails[emailLanguage.value].newComplaintRequestToApprover.message" />
                  </b-form-group>
                </b-tab>
                <b-tab title="Complated Email">
                  <label class="mt-3">Complated Email</label>
                  <div class="my-2">
                    <b-row>
                      <b-col cols="6">
                        <b-card>
                          <b-card-body
                            class="p-0"
                            style="height: 70px;overflow-y: auto;"
                          >
                            <span
                              v-for="(tags, tagsIndex) in $store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].configration.emailTags"
                              :key="tagsIndex"
                              class="mr-2"
                            >
                              <b-badge
                                variant="success"
                                style="cursor: pointer;"
                              >
                                <p @click="setTagValue('[['+tags.text+']]', complaintTypeIndex, emailLanguage.value, 'Complated Email')">{{ tags.text }}</p>
                              </b-badge>
                            </span>
                          </b-card-body>
                        </b-card>
                      </b-col>
                      <b-col cols="6">
                        <b-card>
                          <b-card-body
                            class="p-0"
                            style="height: 70px;overflow-y: auto;"
                          >
                            <span
                              v-for="(platform, platformIndex) in $store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].configration.platformSettings"
                              :key="platformIndex"
                              class="mr-2"
                            >
                              <b-badge
                                variant="success"
                                style="cursor: pointer;"
                              >
                                <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', complaintTypeIndex, emailLanguage.value, 'Complated Email')">{{ platform.platform_variable_name }}</p>
                              </b-badge>
                            </span>
                          </b-card-body>
                        </b-card>
                      </b-col>
                    </b-row>
                  </div>
                  <b-form-group label="Email Subject">
                    <b-form-input
                      v-model="$store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].emails[emailLanguage.value].completedEmail.subject"
                      size="sm"
                    ></b-form-input>
                  </b-form-group>
                  <b-spinner
                    v-if="completedEmailRender"
                    label="Spinning"
                  ></b-spinner>
                  <b-form-group
                    v-else
                    label="Email Body"
                  >
                    <wysiwyg v-model="$store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].emails[emailLanguage.value].completedEmail.message" />
                  </b-form-group>
                </b-tab>
                <b-tab title="On Hold Email">
                  <label class="mt-3">On Hold Email</label>
                  <div class="my-2">
                    <b-row>
                      <b-col cols="6">
                        <b-card>
                          <b-card-body
                            class="p-0"
                            style="height: 70px;overflow-y: auto;"
                          >
                            <span
                              v-for="(tags, tagsIndex) in $store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].configration.emailTags"
                              :key="tagsIndex"
                              class="mr-2"
                            >
                              <b-badge
                                variant="success"
                                style="cursor: pointer;"
                              >
                                <p @click="setTagValue('[['+tags.text+']]', complaintTypeIndex, emailLanguage.value, 'On Hold Email')">{{ tags.text }}</p>
                              </b-badge>
                            </span>
                          </b-card-body>
                        </b-card>
                      </b-col>
                      <b-col cols="6">
                        <b-card>
                          <b-card-body
                            class="p-0"
                            style="height: 70px;overflow-y: auto;"
                          >
                            <span
                              v-for="(platform, platformIndex) in $store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].configration.platformSettings"
                              :key="platformIndex"
                              class="mr-2"
                            >
                              <b-badge
                                variant="success"
                                style="cursor: pointer;"
                              >
                                <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', complaintTypeIndex, emailLanguage.value, 'On Hold Email')">{{ platform.platform_variable_name }}</p>
                              </b-badge>
                            </span>
                          </b-card-body>
                        </b-card>
                      </b-col>
                    </b-row>
                  </div>
                  <b-form-group label="Email Subject">
                    <b-form-input
                      v-model="$store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].emails[emailLanguage.value].onHoldEmail.subject"
                      size="sm"
                    ></b-form-input>
                  </b-form-group>
                  <b-spinner
                    v-if="onHoldEmailRender"
                    label="Spinning"
                  ></b-spinner>
                  <b-form-group
                    v-else
                    label="Email Body"
                  >
                    <wysiwyg v-model="$store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].emails[emailLanguage.value].onHoldEmail.message" />
                  </b-form-group>
                </b-tab>
                <b-tab title="New Complaint Request Email">
                  <label class="mt-3">New Complaint Request Email</label>
                  <div class="my-2">
                    <b-row>
                      <b-col cols="6">
                        <b-card>
                          <b-card-body
                            class="p-0"
                            style="height: 70px;overflow-y: auto;"
                          >
                            <span
                              v-for="(tags, tagsIndex) in $store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].configration.emailTags"
                              :key="tagsIndex"
                              class="mr-2"
                            >
                              <b-badge
                                variant="success"
                                style="cursor: pointer;"
                              >
                                <p @click="setTagValue('[['+tags.text+']]', complaintTypeIndex, emailLanguage.value, 'New Complaint Request Email')">{{ tags.text }}</p>
                              </b-badge>
                            </span>
                          </b-card-body>
                        </b-card>
                      </b-col>
                      <b-col cols="6">
                        <b-card>
                          <b-card-body
                            class="p-0"
                            style="height: 70px;overflow-y: auto;"
                          >
                            <span
                              v-for="(platform, platformIndex) in $store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].configration.platformSettings"
                              :key="platformIndex"
                              class="mr-2"
                            >
                              <b-badge
                                variant="success"
                                style="cursor: pointer;"
                              >
                                <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', complaintTypeIndex, emailLanguage.value, 'New Complaint Request Email')">{{ platform.platform_variable_name }}</p>
                              </b-badge>
                            </span>
                          </b-card-body>
                        </b-card>
                      </b-col>
                    </b-row>
                  </div>
                  <b-form-group label="Email Subject">
                    <b-form-input
                      v-model="$store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].emails[emailLanguage.value].newComplaintRequestEmail.subject"
                      size="sm"
                    ></b-form-input>
                  </b-form-group>
                  <b-spinner
                    v-if="newComplaintRequestToApproverRender"
                    label="Spinning"
                  ></b-spinner>
                  <b-form-group
                    v-else
                    label="Email Body"
                  >
                    <wysiwyg v-model="$store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].emails[emailLanguage.value].newComplaintRequestEmail.message" />
                  </b-form-group>
                </b-tab>
              </b-tabs>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import { HTTP } from "../../../../../utils/HTTP";
export default {
  name: "AddModalComponents",
  data () {
    return {
      isLoading: false,
      currenciesOptions: [],
      totalRows: 0,
      fromRows: 0,
      toRows: 0,
      filter: null,
      perPage: 10,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      staticFields: [
        { key: "contact_name", label: "Contact Name", sortable: true },
        { key: "actions", label: "Select_employee", sortable: true },
      ],
      newComplaintRequestToApproverRender: false,
      completedEmailRender: false,
      onHoldEmailRender: false,
      newComplaintRequestEmailRender: false
    };
  },
  computed: {
    rows () {
      return this.totalRows;
    },
  },
  mounted () {
    this.getCurrenciesList();
  },
  methods: {
    setTagValue ( selectedValue, complaintTypeIndex, emailLanguageValue, emailTab ) {
      // in this function we are adding email tags or platform variables as per in which email type user stands
      // in selectedValue key it has email tag value or platform variable value as where user clicks with email tags are in mustache syntax like {{emailTagValue}} and platform variable value is in multidimensional array syntax like [[platformVariableValue]]
      // in complaintTypeIndex shows in which confiugration index object we have to added tag or variable
      // in emailLanguageValue shows in which language object user adding email tag or platform variable means in which language tab user stand
      // in emailTab shows in which email type object user stand means in which email types object user want to add email tag or platform variable

      let newComplaintRequestToApprover = null;
      let completedEmail = null;
      let onHoldEmail = null;
      let newComplaintRequestEmail = null;
      if ( emailTab == 'Complaint Request To Approver' ) {
        if ( this.$store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].emails[emailLanguageValue].newComplaintRequestToApprover.message == null ) {
          this.$store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].emails[emailLanguageValue].newComplaintRequestToApprover.message = selectedValue
        } else {
          newComplaintRequestToApprover = this.$store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].emails[emailLanguageValue].newComplaintRequestToApprover.message + '' + selectedValue;
          this.$store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].emails[emailLanguageValue].newComplaintRequestToApprover.message = newComplaintRequestToApprover;
        }
        this.newComplaintRequestToApproverRender = true;
        setTimeout( () => {
          this.newComplaintRequestToApproverRender = false;
        }, 100 );
      }
      if ( emailTab == 'Complated Email' ) {
        if ( this.$store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].emails[emailLanguageValue].completedEmail.message == null ) {
          this.$store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].emails[emailLanguageValue].completedEmail.message = selectedValue
        } else {
          completedEmail = this.$store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].emails[emailLanguageValue].completedEmail.message + '' + selectedValue;
          this.$store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].emails[emailLanguageValue].completedEmail.message = completedEmail;
        }
        this.completedEmailRender = true;
        setTimeout( () => {
          this.completedEmailRender = false;
        }, 100 );
      }
      if ( emailTab == 'On Hold Email' ) {
        if ( this.$store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].emails[emailLanguageValue].onHoldEmail.message == null ) {
          this.$store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].emails[emailLanguageValue].onHoldEmail.message = selectedValue
        } else {
          onHoldEmail = this.$store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].emails[emailLanguageValue].onHoldEmail.message + '' + selectedValue;
          this.$store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].emails[emailLanguageValue].onHoldEmail.message = onHoldEmail;
        }
        this.onHoldEmailRender = true;
        setTimeout( () => {
          this.onHoldEmailRender = false;
        }, 100 );
      }
      if ( emailTab == 'New Complaint Request Email' ) {
        if ( this.$store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].emails[emailLanguageValue].newComplaintRequestEmail.message == null ) {
          this.$store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].emails[emailLanguageValue].newComplaintRequestEmail.message = selectedValue
        } else {
          newComplaintRequestEmail = this.$store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].emails[emailLanguageValue].newComplaintRequestEmail.message + '' + selectedValue;
          this.$store.state.complaintSettingsWorkFlowCategories[complaintTypeIndex].emails[emailLanguageValue].newComplaintRequestEmail.message = newComplaintRequestEmail;
        }
        this.newComplaintRequestEmailRender = true;
        setTimeout( () => {
          this.newComplaintRequestEmailRender = false;
        }, 100 );
      }
    },
    async getCurrenciesList () {
      this.currenciesOptions = [];
      this.isLoading = true;
      try {
        let result = await HTTP(
          "get",
          "api/v1/constants/currencies-list",
          null
        );
        this.currenciesOptions = result.data.currency;
        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
    },
    async getEmployeeTableData () {
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + ( this.sortDesc == true ? "desc" : "asc" ),
        per_page: this.perPage,
        page: this.currentPage,
      };
      this.isLoading = true;
      let result = HTTP( "post", "api/v1/employees/get-employee-list", formData );

      return result
        .then( ( response ) => {
          const items = response.data.data;
          this.isLoading = false;
          this.totalRows = response.data.total;
          this.fromRows = response.data.from;
          this.toRows = response.data.to;
          return items;
        } )
        .catch( ( error ) => {
          this.isLoading = false;
          return [error];
        } );
    },
    onSelectedEmployee ( data ) {
      this.$store.state.complaintSettingsWorkFlowCategories[
        this.complaintTypeIndex
      ].approvers.approversList.push( {
        id: data.item.id,
        email: data.item.email,
        name: data.item.first_name + " " + data.item.last_name,
        is_senior_management: data.item.is_senior_management,
        is_c_suite_officer: data.item.is_c_suite_officer,
      } );
    },
    deleteSelectedEmployee ( employeeIndex ) {
      this.$store.state.complaintSettingsWorkFlowCategories[
        this.complaintTypeIndex
      ].approvers.approversList.splice( employeeIndex, 1 );
    },
  },
  props: {
    complaintTypeIndex: Number,
    selectedLanguage: Array,
    emailTagsOptions: Array,
    platformSettingOptions: Array,
    selectedLanguageLength: Number
  },
};
</script>
<style>
.complaints-languages-tabs-layout {
  width: 50rem;
  transform: translateX(16.3rem);
}
</style>